import { createContext, useContext, useState, useCallback, useEffect } from "react";
import { trackEvent } from "@/lib/analytics";

const LeadModalContext = createContext({
  // Safe default so components reused OUTSIDE the provider (e.g. carousels on the
  // new no-ads site) render fine — openModal simply does nothing there.
  open: false, openModal: () => {}, closeModal: () => {}, setOpen: () => {}, launch: null,
});
const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function LeadModalProvider({ children }) {
  const [open, setOpen] = useState(false);
  const [launch, setLaunch] = useState(null);

  // Prefetch the real "businesses started" count once (this provider is always
  // mounted), so the counter is ready the instant the modal opens — no pop-in.
  useEffect(() => {
    const ctrl = new AbortController();
    fetch(`${API_BASE}/launch-stats`, { signal: ctrl.signal })
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => { if (d) setLaunch(d); })
      .catch(() => { /* counter is optional */ });
    return () => ctrl.abort();
  }, []);

  const openModal = useCallback(() => {
    trackEvent("get_started"); // funnel: clicked Get Started -> lead form shown
    setOpen(true);
  }, []);

  const closeModal = useCallback(() => setOpen(false), []);

  return (
    <LeadModalContext.Provider value={{ open, openModal, closeModal, setOpen, launch }}>
      {children}
    </LeadModalContext.Provider>
  );
}

export function useLeadModal() {
  return useContext(LeadModalContext);
}
